export default function passwordResetFormDirective() {
  return {
    template: require('./password-reset.html'),
    scope: {},
    controller: 'PasswordResetFormController',
    controllerAs: 'passwordResetVM',
    bindToController: true,
    replace: true,
  };
}
